import $ from 'jquery'

let $modal = null

export function init() {
  $(document).on('click', '[data-close-modal]', function (event) {
    $modal.fadeOut(200)
    event.preventDefault()
  })

  $(document).on('click', '[data-show-modal]', function (event) {
    if ($modal) {
      $modal.remove()
    }

    const data = $(this).data()

    // create modal from template
    $modal = $($(`#${data.showModal}`).text())

    switch (data.showModal) {
      case 'waitlist':
        setupWaitlist($modal, data)
    }

    $modal.hide()
    $(document.body).append($modal)
    $modal.fadeIn()

    event.preventDefault()
  })
}

function setupWaitlist($modal, data) {
  $('[data-event-name]', $modal).text(data.eventName)
  $('[data-event-id]', $modal).val(data.eventId)
}
